export default __webpack_public_path__ + "static/media/buster_klein_51.5ec355f7.jpg";